export default {
    DetailsOfThirdPartyAfterSalesOrder: {
        Details: 'Third-party after-sales order details',
        Normal: 'Normal flow',
        The: 'The third-party after-sales order has been successfully transferred to the internal after-sales order for processing.',
        Suspend: 'Suspend',
        Reason: 'Reason:',
        Basic: 'Account Information',
        Store: 'Store name',
        After: 'After-sales type',
        Platform: 'Platform status',
        sales: 'After-sales reason',
        remarks: 'After-sales Remarks',
        Buyer: 'Buyer information',
        nickname: 'Buyer nickname',
        Return: 'Return courier',
        Refund: 'Refund logistics number',
        Original: 'Original receiving address',
        Exchange: 'Exchange recipient',
        recipient: 'Exchange receiving mobile',
        address: 'Exchange receiving address',
        Associated: 'Associated documents',
        Third: 'Third-party after-sales Order No.',
        party: 'Original Customer Order No.',
        Internal: 'Internal after-sales Order No.',
        order: 'Internal original Order No.',
        number: 'Platform exchange Order No.',
        time: 'Order time',
        Application: 'After-sales application time',
        completion: 'After-sales completion time',
        Timeout: 'Timeout',
        Creation: 'Creation time',
        products: 'After-sales product details',
        item: 'Replacement product details',
        form: {
            Original: 'Original sub-Order No.',
            Product: 'Product quantity',
            System: 'System product code',
            SKU: 'System SKU code',
            Comment: 'Remarks',
            ID: 'Platform product ID',
            code: 'Platform product code',
            PlatformID: 'Platform specification ID',
            Platformcode: 'Platform specification code',
            productname: 'Platform product name',
            Unit: 'Product unit price',
            amount: 'Transaction amount',
            Refund: 'Refund amount',

            note: 'Exchange Order No.',
            item: 'Exchange product ID',
            itemcode: 'Exchange product code',
            ExchangeID: 'Exchange specification ID',
            Exchangecode: 'Exchange specification code',
            Exchangename: 'Exchange product name',
            price: 'Exchange product unit price',
        }
    }
};
